import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { submit, reset } from 'redux-form/immutable';

import FlatButton from 'material-ui/FlatButton';
import {
  Step,
  Stepper,
  StepLabel,
} from 'material-ui/Stepper';

import ReduxDialog from '../Common/ReduxDialog';
import { showDialog, hideDialog, showWarning } from '../../actions/dialogs';
import Page1 from './Page1';
import Page2 from './Page2';
import Page3 from './Page3';
import {
  fetchCustomers,
} from '../../actions/customers';
import {
  fetchEmployees,
} from '../../actions/employees';

import { saveJobFormHandler } from '../../routines';
import { sortStrings } from '../../utils/helper';

import styles from './styles';

// const isAfterOrEqualStart = (value, values) => {
//   console.log('furueInc', value, values);
//   const result = moment(value).startOf('d').isSameOrAfter(moment(values.get('start')).startOf('d'));
//   console.log('isAfterOrEqualStart', result);
//   return result ? undefined : 'End date must be after start date';
// };

class CreateJobDialog extends React.Component {
  static propTypes = {
    dialogs: PropTypes.object.isRequired,
    showDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    showWarning: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    // handleSubmit: PropTypes.func.isRequired,

    fetchEmployees: PropTypes.func.isRequired,
    employees: PropTypes.array.isRequired,
    fetchCustomers: PropTypes.func.isRequired,
    customers: PropTypes.array.isRequired,

    submit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    onRequestClose: PropTypes.func.isRequired,
  };

  //TODO auth0 - review
  // static contextTypes = {
  //   router: React.PropTypes.object.isRequired,
  // };

  state = {
    finished: false,
    stepIndex: 0,

    // contacts: this.addNewContact(),
    // addresses: [],
  };

  componentWillMount() {
    this.props.fetchCustomers();
    this.props.reset('wizard');
  }

  handleNext = () => {
    const { stepIndex } = this.state;
    this.setState({
      stepIndex: stepIndex + 1,
      finished: stepIndex >= 2,
    });

    if (stepIndex >= 2) {
      this.props.dispatch(submit('CreateJob'));
    }
  };

  handlePrev = () => {
    const { stepIndex } = this.state;
    if (stepIndex > 0) {
      this.setState({ stepIndex: stepIndex - 1 });
    }
  };

  // handleSelectTaskProfiles = (taskProfiles) => {
  //   console.log('handleSelectTaskProfiles', taskProfiles);
  //   this.props.setTaskProfiles(this.props.job, taskProfiles);
  // };
  //
  // handlePreferredItemsChanged = (preferredItems) => {
  //   console.log('handlePreferredItemsChanged', preferredItems);
  //   this.props.setPreferredItems(this.props.job, preferredItems);
  // };

  // renderTaskProfiles() {
  //   return (
  //     <TaskProfileDrilldown
  //       taskProfiles={this.props.job.taskProfiles}
  //       onChange={this.handleSelectTaskProfiles}
  //       selectable
  //     />);
  // }

  // renderPreferredItems() {
  //   return <PreferredItems items={this.props.job.preferredItems} onChange={this.handlePreferredItemsChanged}/>;
  // }

  getStepContent(stepIndex) {
    switch (stepIndex) {
      case 0:
        return <Page1 customers={this.props.customers} onSubmit={this.handleNext}/>;
      case 1:
        return <Page2 onSubmit={this.handleNext}/>;
      case 2:
        return <Page3 employees={this.props.employees} onSubmit={saveJobFormHandler} onRequestClose={this.props.onRequestClose}/>;
      default:
        return 'Invalid step';
    }
  }

  render() {
    const { stepIndex } = this.state;

    const actions = [
      <FlatButton
        label="Cancel"
        primary
        onClick={() => {
          this.setState({ primaryContact: '' });
          return this.props.hideDialog('createJob');
        }}
      />,
      <FlatButton
        label={stepIndex === 2 ? 'Finish' : 'Next'}
        primary
        keyboardFocused
        onClick={() => this.props.submit('wizard')}
      />,
    ];
    return (
      <ReduxDialog
        name="createJob"
        title="Create Job"
        actions={actions}
        modal={false}
        onRequestClose={this.handleClose}
        autoScrollBodyContent
        bodyStyle={styles.body}
      >
        <Stepper activeStep={stepIndex}>
          <Step>
            <StepLabel>Select Customer</StepLabel>
          </Step>
          <Step>
            <StepLabel>Configure Job</StepLabel>
          </Step>
          <Step>
            <StepLabel>Resources</StepLabel>
          </Step>
          {/*<Step>*/}
          {/*<StepLabel>Task Profiles</StepLabel>*/}
          {/*</Step>*/}
          {/*<Step>*/}
          {/*<StepLabel>Preferred Items</StepLabel>*/}
          {/*</Step>*/}
        </Stepper>
        { this.getStepContent(stepIndex)}
      </ReduxDialog>
    );
  }
}

// const form = reduxForm({
//   form: 'CreateJob',  // a unique identifier for this form
//   // enableReinitialize: true,
//   initialValues: fromJS({
//     start: moment().startOf('d').add(1, 'd').toDate(),
//     end: moment().startOf('d').add(1, 'd').toDate(),
//     profile: null,
//     created: { at: new Date().toISOString() },
//   }),
//   onSubmit: (values, dispatch) => {
//     const data = fromJS({}).set('job', values);
//     return dispatch(saveJobRoutine.trigger(data));
//   },
//   onSubmitSuccess: (result, dispatch, props) => {
//     console.log('onSubccess', result);
//     console.log('dispatch', dispatch);
//     // console.log('result.payload.toJS()', result.payload.toJS());
//
//     const context = {
//       type: 'warning',
//       title: 'Upload Tasks?',
//       message: 'Would you like to upload tasks now?',
//       buttons: [
//         <FlatButton
//           label="No"
//           onClick={() => props.hideDialog('confirm')}
//         />,
//         <FlatButton
//           label="Yes"
//           onClick={() => {
//             props.hideDialog('confirm');
//             props.showDialog('taskUpload');
//           }}
//         />,
//       ],
//     };
//
//     props.showDialog('confirm', context);
//     props.onRequestClose(result.payload.toJS());
//   },
// })(CreateJobDialog);

function mapStateToProps(state) {
  const customers = [{
    id: '0',
    name: ' -- Add New Customer --',
  }].concat(state.get('customers').get('customers').toJS() || []).sort((a, b) => sortStrings(a.name, b.name));

  return {
    customers,
    employees: state.get('employees').get('employees').toJS(),
    dialogs: state.get('dialogs').get('dialogs').toJS(),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    showDialog,
    hideDialog,
    showWarning,
    fetchCustomers,
    fetchEmployees,
    dispatch,
    submit,
    reset,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateJobDialog);



// WEBPACK FOOTER //
// ./src/components/CreateJobDialog/index.js